exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-dc688858] {\n    width: 100%;\n    height: 135px;\n}\n.desktop-hs > li[data-v-dc688858],\n.desktop-item[data-v-dc688858] {\n    scroll-snap-align: center;\n    /*padding: calc(var(--gutter) / 2 * 1.5);*/\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    /*align-items: center;*/\n    background: #fff;\n    border-radius: 8px;\n    overflow: hidden;\n    max-height: 280px;\n    min-height: 280px;\n}\n\n", ""]);

// exports
